import { render, staticRenderFns } from "./averagenum.vue?vue&type=template&id=2b4b81fe&scoped=true&"
import script from "./averagenum.vue?vue&type=script&lang=js&"
export * from "./averagenum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b81fe",
  null
  
)

export default component.exports